import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafCard } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/card/card';

@Component({
  selector: 'cigna-leaf-card',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-card [variant]="variant" [align]="align"
      ><ng-content></ng-content
    ></leaf-card>
  `,
})
export class CignaLeafCardComponent {
  @Input() variant: LeafCard['variant'];
  @Input() align: LeafCard['align'];
}
